import { useContext } from "react";
import PortfolioContext from "../contexts/PortfolioContext";

const usePortfolio = () => useContext(PortfolioContext);

export default usePortfolio;
